var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaunchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d9322e;}.b{opacity:0.301;}.c{fill:#fff;}.d{fill:none;stroke-linecap:round;}.d,.e{stroke:#000;}.f{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 121,
    height: 121,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4a0404",
    floodOpacity: 0.376
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1608 -869)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "matrix(1, 0, 0, 1, 1608, 869)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 51.5,
    cy: 51.5,
    r: 51.5,
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10,56.885a10,10,0,0,1-10-10V25.8a10,10,0,0,1,10-10H46.649L55.5,3V16.737A10,10,0,0,1,61.267,25.8V46.884a10,10,0,0,1-10,10Z",
    transform: "translate(1695.025 964.572) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M10,56.885a10,10,0,0,1-10-10V25.8a10,10,0,0,1,10-10H46.649L55.5,3V16.737A10,10,0,0,1,61.267,25.8V46.884a10,10,0,0,1-10,10Z",
    transform: "translate(1700.792 958.085) rotate(180)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.5,
    cy: 6,
    rx: 5.5,
    ry: 6,
    transform: "translate(1653 912)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.5,
    cy: 6,
    rx: 5.5,
    ry: 6,
    transform: "translate(1677 912)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1664.266 930.392)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1736,3426.5s3.309,2.2,6.413,2.2a11.1,11.1,0,0,0,5.581-1.906c.2-.123.422-.292.422-.292",
    transform: "translate(-1736 -3426.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1736.441,3426.735a25.786,25.786,0,0,0,5.936,1.055,26.912,26.912,0,0,0,6.007-1.055c-.077.025-1.6.928-2.5,1.324a7.686,7.686,0,0,1-3.075.659,10.949,10.949,0,0,1-3.781-.659A8.2,8.2,0,0,1,1736.441,3426.735Z",
    transform: "translate(-1736.123 -3426.566)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchIcon);
export default __webpack_public_path__ + "static/media/LaunchIcon.42aa4783db54a8b1977c612d7d699022.svg";
export { ForwardRef as ReactComponent };